var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"login-avatar",on:{"click":_vm.login}},[_vm._v(" Войти ")])
}
var staticRenderFns = []

export { render, staticRenderFns }